/* unplugin-vue-components disabled */import { render } from "./copyright.vue?vue&type=template&id=16e30d8d&scoped=true"
const script = {}

import "./copyright.vue?vue&type=style&index=0&id=16e30d8d&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e30d8d"]])

export default __exports__